import React, { forwardRef } from 'react';
import { SearchBtn } from './search-btn';
import * as ST from './styled';
// eslint-disable-next-line react/display-name
export var SearchInput = forwardRef(function (props, ref) {
    var onClear = props.onClear, onSearch = props.onSearch, isClearBtnHide = props.isClearBtnHide, isSearchBtnHide = props.isSearchBtnHide, isSearchBtnInactive = props.isSearchBtnInactive;
    var clearHandler = function (e) {
        e.stopPropagation();
        if (onClear) {
            onClear();
        }
    };
    var searchHandler = function (e) {
        e.stopPropagation();
        if (onSearch) {
            onSearch();
        }
    };
    return (<ST.SearchWrapper>
            <ST.Input {...props} data-test='search-field' ref={ref}/>
            <ST.BtnWrap>
            {!isClearBtnHide &&
            <ST.ClearBtn onClick={clearHandler}/>}
            {!isSearchBtnHide &&
            <SearchBtn 
            /* @ts-ignore */
            onClick={function (e) { return searchHandler(e); }} isInactive={isSearchBtnInactive}/>}
            </ST.BtnWrap>
        </ST.SearchWrapper>);
});
